import * as React from 'react';
import { TooltipCommonProps } from '../common';

type item = {
  label: string;
  values: number[];
};

export interface StackedBarChartProps {
  dataHook?: string;
  className?: string;
  data?: item[];
  tooltipTemplate?: (item: item) => React.ReactNode;
  tooltipCommonProps?: TooltipCommonProps;
  width?: number;
  height?: number;
  margin?: { top: number; left: number; bottom: number; right: number };
  yAxisTickFormat?: (rawValue: string, parsedValue: string) => string;
}

export default class StackedBarChart extends React.PureComponent<StackedBarChartProps> {}
